import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import ObservationLog from '../../components/ObservationLog';

// Full-page event log, opened in a new browser tab from the observation detail
// page's "open in new tab" action. A focused pop-out: no layout chrome (menu
// bar / breadcrumbs). Reuses the ObservationLog component in standalone mode
// (filtering, export, add-comment; all events, no pagination).
const ObservationLogPage = () => {
  const { id } = useParams();

  useEffect(() => {
    document.title = `Event Log · ${id}`;
  }, [id]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>Event Log</Typography>
      <ObservationLog observationId={id} standalone />
    </Box>
  );
};

export default ObservationLogPage;
